class DigPlugin extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    // Initialisierung des Shadow DOMs
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
          box-sizing: border-box;
        }
        .hidden {
          display: none !important;
        }
        .banner {
          padding: 20px;
          background-color: #ffffff;
          border: 1px solid #000000;
          line-height: 1.3;
          text-align: center;
          font-family: var(--font-family, "Roboto Condensed", sans-serif);
          max-width: 600px;
          margin: 20px auto;
          font-size: 1.2rem;
        }
        .banner p {
          margin: 0 0 10px;
        }
        .banner .headline {
          font-weight: bold;
          font-size: 1.2em;
        }
        .banner .text {
          margin-bottom: 15px;
        }
        .banner .acceptButton {
          background-color: var(--accent-color, #ffffff);
          color: black;
          border: 1px solid black;
          padding: 10px 20px;
          font-weight:700;
          font-size: 1em;
          cursor: pointer;
          font-family: var(--font-family, "Roboto Condensed", sans-serif);
          margin: 0 0 20px 0;
        }
        .banner .footnote {
          font-size: 0.8em;
          color: #555;
        }
        .banner a {
          color: var(--accent-color, #000000);
        }
        .contentContainer {
          display: flex;
          justify-content: center;
          margin: 20px auto;
        }
        .contentContainer > * {
          max-width: 100%;
        }
      </style>
      <div class="consentBanner hidden">
        <div class="banner">
          <p class="headline"></p>
          <p class="text"></p>
          <button class="acceptButton">Inhalt jetzt laden</button>
          <p class="footnote"></p>
        </div>
      </div>
      <div class="contentContainer hidden"></div>
    `;
  }

  connectedCallback() {
    this.type = this.getAttribute('data-type') || this.determineTypeFromContent();
    this.handleTCFEventBound = this.handleTCFEvent.bind(this);
    window.tcfManager.addEventListener(this.handleTCFEventBound);
    this.shadowRoot.querySelector('.acceptButton').addEventListener('click', this.handleAcceptButtonClick.bind(this));
    window.tcfManager.checkConsentStatus(this.type);
    this.applyStyles();
  }

  disconnectedCallback() {
    window.tcfManager.eventListeners = window.tcfManager.eventListeners.filter(callback => callback !== this.handleTCFEventBound);
    this.shadowRoot.querySelector('.acceptButton').removeEventListener('click', this.handleAcceptButtonClick.bind(this));
  }

  handleTCFEvent(eventType, data) {
    if (eventType === 'consentGiven' && data === this.type) {
      this.renderContent();
    } else if (eventType === 'consentRequired' && data === this.type) {
      this.renderConsentBanner();
    }
  }

  handleAcceptButtonClick() {
    window.tcfManager.postCustomConsent(this.type);
  }

  determineTypeFromContent() {
    const templateContent = this.querySelector('template')?.innerHTML.toLowerCase() || '';
    const grantsKeys = Object.keys(window.tcfManager.grants);
    return grantsKeys.find(key => templateContent.includes(key)) || '';
  }

  renderConsentBanner() {
    const banner = this.shadowRoot.querySelector('.consentBanner');
    const embedType = this.type.charAt(0).toUpperCase() + this.type.slice(1); // Capitalize the first letter
    const privacyLink = window.tcfManager.privacyLink;
    const headline = `Wir haben den Inhalt dieser Seite mit einem Inhalt von ${embedType} angereichert.`;
    const text = `Durch das Laden des Inhalts können personenbezogene Daten an Plattformen übermittelt werden, die Daten möglicherweise auch in Drittstaaten außerhalb des EWR ohne angemessenes Datenschutzniveau verarbeiten.`;
    const footnote = `Laden Sie Inhalte von ${embedType} nur, wenn Sie mit dieser Übertragung personenbezoqener Daten einverstanden sind. Mehr Informationen auch zu Widerrufsmöglichkeiten finden Sie in der <a href="${privacyLink}" target="_blank" style="color:black;">Datenschutzerklärung</a>.`;

    banner.querySelector('.headline').innerHTML = headline;
    banner.querySelector('.text').textContent = text;
    banner.querySelector('.footnote').innerHTML = footnote;
    banner.classList.remove('hidden');
    const contentContainer = this.shadowRoot.querySelector('.contentContainer');
    
    contentContainer.innerHTML="";
    contentContainer.classList.add('hidden');
  }

  renderContent() {
    const banner = this.shadowRoot.querySelector('.consentBanner');
    const contentContainer = this.shadowRoot.querySelector('.contentContainer');
    const template = this.querySelector('template');

    // Entfernen des Consent-Banners
    banner.classList.add('hidden');
    contentContainer.classList.remove('hidden');

    // Inhalt des Templates in den Container klonen und anzeigen
    if (template) {
      contentContainer.innerHTML = '';
      contentContainer.appendChild(template.content.cloneNode(true));
    }
  }

  applyStyles() {
    const accentColor = window.tcfManager.accentColor;
    const fontFamily = window.tcfManager.fontFamily;
    this.shadowRoot.host.style.setProperty('--accent-color', accentColor);
    this.shadowRoot.host.style.setProperty('--font-family', fontFamily);
  }
}

// Registrieren Sie die Webkomponente
customElements.define('dig-plugin', DigPlugin);
